document.addEventListener("DOMContentLoaded", function () {

  const nameInput = document.getElementById("nbName");
  const surnameInput = document.getElementById("nbSurname");
  const flatInput = document.getElementById("nbFlat");

  const overlay = document.getElementById("nbLiveText");
  const liveName = document.getElementById("liveName");
  const liveSurname = document.getElementById("liveSurname");
  const liveFlat = document.getElementById("liveFlat");
  const previewBtn = document.getElementById("nbPreviewBtn");
const modal = document.getElementById("nbPreviewModal");
const closeBtn = document.querySelector(".nb-close");

if (previewBtn) {
  previewBtn.addEventListener("click", function () {

    const name = document.getElementById("nbName").value;
    const surname = document.getElementById("nbSurname").value;
    const flat = document.getElementById("nbFlat").value;

    if (!name && !surname && !flat) {
      alert("Please enter at least one field");
      return;
    }

    document.getElementById("pvName").textContent = name;
    document.getElementById("pvSurname").textContent = surname;
    document.getElementById("pvFlat").textContent = flat;

    modal.style.display = "block";
  });
}

if (closeBtn) {
  closeBtn.addEventListener("click", () => modal.style.display = "none");
}

window.addEventListener("click", (e) => {
  if (e.target === modal) modal.style.display = "none";
});


  if (!overlay) return;

  // Read metafields from HTML
  overlay.style.fontFamily = overlay.dataset.font;
  overlay.style.fontSize = overlay.dataset.size + "px";
  overlay.style.lineHeight = overlay.dataset.line;

  function updatePreview() {
    liveName.textContent = nameInput.value;
    liveSurname.textContent = surnameInput.value;
    liveFlat.textContent = flatInput.value;
  }

  nameInput.addEventListener("input", updatePreview);
  surnameInput.addEventListener("input", updatePreview);
  flatInput.addEventListener("input", updatePreview);

});

  

  const form = document.getElementById("nbForm");

if (form) {
  form.addEventListener("submit", function () {
    document.getElementById("propName").value =
      document.getElementById("nbName").value;

    document.getElementById("propSurname").value =
      document.getElementById("nbSurname").value;

    document.getElementById("propFlat").value =
      document.getElementById("nbFlat").value;
  });
}

const submitBtn = document.querySelector(".nb-submit");

if (submitBtn) {
  submitBtn.addEventListener("click", function () {

    const name = document.getElementById("nbName").value;
    const surname = document.getElementById("nbSurname").value;
    const flat = document.getElementById("nbFlat").value;

    if (!name && !surname && !flat) {
      alert("Please enter at least one field");
      return;
    }

    // Build mail content
    const message =
      "New Nameboard Customization\n\n" +
      "Name: " + name + "\n" +
      "Surname: " + surname + "\n" +
      "Flat No: " + flat + "\n\n" +
      "Product: " + document.title;

    // Fill contact form
    document.getElementById("mailName").value = name || "Nameboard Customer";
    document.getElementById("mailBody").value = message;

    // SEND MAIL
    document.getElementById("nbMailForm").submit();

  });
}
